module.exports = __webpack_public_path__ + "ca5696e4104f7c9e3f519cc9a02b5967.jpg";